/**
 * Verlof React Query Hooks (Spoor 2, Verlof MVP) — Story 3.1
 */

import { useQuery } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';

export const approvalQueueKeys = {
  all: ['leave-requests', 'approval-queue'] as const,
};

/** Story 3.1: goedkeuringslijst met beslis-context (team-scope, of alles voor HR/admin). */
export function useApprovalQueue() {
  return useQuery({
    queryKey: approvalQueueKeys.all,
    queryFn: () => verlofApi.getApprovalQueue(),
    staleTime: 1000 * 30, // 30s — een wachtrij die snel kan wijzigen (nieuwe aanvragen, besluiten door collega-leidinggevenden)
  });
}
